import { render } from "./privacyPolicy.vue?vue&type=template&id=416e6642"
import script from "./privacyPolicy.vue?vue&type=script&lang=js"
export * from "./privacyPolicy.vue?vue&type=script&lang=js"

import "./privacyPolicy.vue?vue&type=style&index=0&id=416e6642&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__